/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SaPayslipItem } from '../model/saPayslipItem';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SaPayslipItemService {

    protected basePath = 'https://gateway.dev.meu-solutions.com/staginganawork';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param sectionId 
     * @param sheetID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaPayslipSectionsSectionIdMySaPayslipItemDataGet(sectionId: string, sheetID?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaPayslipSectionsSectionIdMySaPayslipItemDataGet(sectionId: string, sheetID?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaPayslipSectionsSectionIdMySaPayslipItemDataGet(sectionId: string, sheetID?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaPayslipSectionsSectionIdMySaPayslipItemDataGet(sectionId: string, sheetID?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sectionId === null || sectionId === undefined) {
            throw new Error('Required parameter sectionId was null or undefined when calling apiSaPayslipSectionsSectionIdMySaPayslipItemDataGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (sheetID !== undefined && sheetID !== null) {
            queryParameters = queryParameters.set('sheetID', <any>sheetID);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/saPayslipSections/${encodeURIComponent(String(sectionId))}/mySaPayslipItem/data`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sectionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaPayslipSectionsSectionIdSaPayslipItemGet(sectionId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemGet(sectionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemGet(sectionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemGet(sectionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sectionId === null || sectionId === undefined) {
            throw new Error('Required parameter sectionId was null or undefined when calling apiSaPayslipSectionsSectionIdSaPayslipItemGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/saPayslipSections/${encodeURIComponent(String(sectionId))}/saPayslipItem`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sectionId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaPayslipSectionsSectionIdSaPayslipItemsIdDelete(sectionId: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemsIdDelete(sectionId: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemsIdDelete(sectionId: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemsIdDelete(sectionId: string, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sectionId === null || sectionId === undefined) {
            throw new Error('Required parameter sectionId was null or undefined when calling apiSaPayslipSectionsSectionIdSaPayslipItemsIdDelete.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiSaPayslipSectionsSectionIdSaPayslipItemsIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/saPayslipSections/${encodeURIComponent(String(sectionId))}/saPayslipItems/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sectionId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaPayslipSectionsSectionIdSaPayslipItemsIdGet(sectionId: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemsIdGet(sectionId: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemsIdGet(sectionId: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemsIdGet(sectionId: string, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sectionId === null || sectionId === undefined) {
            throw new Error('Required parameter sectionId was null or undefined when calling apiSaPayslipSectionsSectionIdSaPayslipItemsIdGet.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiSaPayslipSectionsSectionIdSaPayslipItemsIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/saPayslipSections/${encodeURIComponent(String(sectionId))}/saPayslipItems/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sectionId 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaPayslipSectionsSectionIdSaPayslipItemsIdPut(sectionId: string, id: string, body?: SaPayslipItem, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemsIdPut(sectionId: string, id: string, body?: SaPayslipItem, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemsIdPut(sectionId: string, id: string, body?: SaPayslipItem, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemsIdPut(sectionId: string, id: string, body?: SaPayslipItem, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sectionId === null || sectionId === undefined) {
            throw new Error('Required parameter sectionId was null or undefined when calling apiSaPayslipSectionsSectionIdSaPayslipItemsIdPut.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiSaPayslipSectionsSectionIdSaPayslipItemsIdPut.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/saPayslipSections/${encodeURIComponent(String(sectionId))}/saPayslipItems/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sectionId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaPayslipSectionsSectionIdSaPayslipItemsPost(sectionId: string, body?: SaPayslipItem, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemsPost(sectionId: string, body?: SaPayslipItem, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemsPost(sectionId: string, body?: SaPayslipItem, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaPayslipSectionsSectionIdSaPayslipItemsPost(sectionId: string, body?: SaPayslipItem, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sectionId === null || sectionId === undefined) {
            throw new Error('Required parameter sectionId was null or undefined when calling apiSaPayslipSectionsSectionIdSaPayslipItemsPost.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/saPayslipSections/${encodeURIComponent(String(sectionId))}/saPayslipItems`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param targetSheetID 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaPayslipSectionsTargetSheetIDSaPayslipItemsClonePayslipItemPost(targetSheetID: string, body?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaPayslipSectionsTargetSheetIDSaPayslipItemsClonePayslipItemPost(targetSheetID: string, body?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaPayslipSectionsTargetSheetIDSaPayslipItemsClonePayslipItemPost(targetSheetID: string, body?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaPayslipSectionsTargetSheetIDSaPayslipItemsClonePayslipItemPost(targetSheetID: string, body?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (targetSheetID === null || targetSheetID === undefined) {
            throw new Error('Required parameter targetSheetID was null or undefined when calling apiSaPayslipSectionsTargetSheetIDSaPayslipItemsClonePayslipItemPost.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/saPayslipSections/${encodeURIComponent(String(targetSheetID))}/saPayslipItems/clonePayslipItem`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
